import React, { Children } from 'react';
export function PrivacyPolicyContent() {
  return <div className="prose prose-sm max-w-none text-gray-700" data-id="element-83">
      <p className="text-sm text-gray-500 mb-6" data-id="element-84">
        <strong data-id="element-85">Effective Date:</strong> January 1, 2025
      </p>

      <section className="mb-8" data-id="element-86">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-87">
          1. Introduction
        </h3>
        <p data-id="element-88">
          Welcome to HealthProductsGuru ("we," "our," or "us"). We are committed
          to protecting your privacy and ensuring the security of your personal
          information. This Privacy Policy explains how we collect, use,
          disclose, and safeguard your information when you visit our website
          healthproductsguru.com (the "Site") and purchase our products.
        </p>
      </section>

      <section className="mb-8" data-id="element-89">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-90">
          2. Information We Collect
        </h3>

        <h4 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-91">
          2.1 Personal Information
        </h4>
        <p className="mb-4" data-id="element-92">
          We may collect personal information that you voluntarily provide to us
          when you:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-93">
          <li data-id="element-94">Make a purchase or place an order</li>
          <li data-id="element-95">Create an account</li>
          <li data-id="element-96">Subscribe to our newsletter</li>
          <li data-id="element-97">Contact customer support</li>
          <li data-id="element-98">Participate in surveys or promotions</li>
        </ul>
        <p className="mb-4" data-id="element-99">This information may include:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-100">
          <li data-id="element-101">
            Name and contact information (email address, phone number, shipping
            address)
          </li>
          <li data-id="element-102">Payment information (credit card details, billing address)</li>
          <li data-id="element-103">Account credentials (username, password)</li>
          <li data-id="element-104">Purchase history and preferences</li>
        </ul>

        <h4 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-105">
          2.2 Automatically Collected Information
        </h4>
        <p className="mb-4" data-id="element-106">
          When you visit our Site, we automatically collect certain information
          about your device and browsing behavior, including:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-107">
          <li data-id="element-108">IP address and device identifiers</li>
          <li data-id="element-109">Browser type and version</li>
          <li data-id="element-110">Operating system</li>
          <li data-id="element-111">Pages visited and time spent on pages</li>
          <li data-id="element-112">Referring website addresses</li>
          <li data-id="element-113">Cookies and similar tracking technologies</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-114">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-115">
          3. How We Use Your Information
        </h3>
        <p className="mb-4" data-id="element-116">
          We use the information we collect for the following purposes:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-117">
          <li data-id="element-118">
            <strong data-id="element-119">Order Processing:</strong> To process and fulfill your
            orders, including payment processing and shipping
          </li>
          <li data-id="element-120">
            <strong data-id="element-121">Customer Service:</strong> To respond to your inquiries and
            provide customer support
          </li>
          <li data-id="element-122">
            <strong data-id="element-123">Account Management:</strong> To create and manage your
            account
          </li>
          <li data-id="element-124">
            <strong data-id="element-125">Marketing Communications:</strong> To send you promotional
            emails, newsletters, and special offers (you can opt-out at any
            time)
          </li>
          <li data-id="element-126">
            <strong data-id="element-127">Site Improvement:</strong> To analyze usage patterns and
            improve our Site's functionality and user experience
          </li>
          <li data-id="element-128">
            <strong data-id="element-129">Fraud Prevention:</strong> To detect and prevent fraudulent
            transactions and protect against security threats
          </li>
          <li data-id="element-130">
            <strong data-id="element-131">Legal Compliance:</strong> To comply with applicable laws,
            regulations, and legal processes
          </li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-132">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-133">
          4. Information Sharing and Disclosure
        </h3>
        <p className="mb-4" data-id="element-134">
          We do not sell your personal information. We may share your
          information with:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-135">
          <li data-id="element-136">
            <strong data-id="element-137">Service Providers:</strong> Third-party companies that help
            us operate our business (payment processors, shipping companies,
            email service providers)
          </li>
          <li data-id="element-138">
            <strong data-id="element-139">Business Transfers:</strong> In connection with a merger,
            acquisition, or sale of assets
          </li>
          <li data-id="element-140">
            <strong data-id="element-141">Legal Requirements:</strong> When required by law or to
            protect our rights and safety
          </li>
          <li data-id="element-142">
            <strong data-id="element-143">With Your Consent:</strong> When you explicitly agree to
            share your information
          </li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-144">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-145">
          5. Cookies and Tracking Technologies
        </h3>
        <p className="mb-4" data-id="element-146">
          We use cookies and similar tracking technologies to enhance your
          browsing experience, analyze site traffic, and personalize content.
          You can control cookies through your browser settings, but disabling
          cookies may affect site functionality.
        </p>
      </section>

      <section className="mb-8" data-id="element-147">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-148">
          6. Data Security
        </h3>
        <p data-id="element-149">
          We implement appropriate technical and organizational security
          measures to protect your personal information from unauthorized
          access, disclosure, alteration, or destruction. However, no method of
          transmission over the internet is 100% secure, and we cannot guarantee
          absolute security.
        </p>
      </section>

      <section className="mb-8" data-id="element-150">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-151">
          7. Your Rights and Choices
        </h3>
        <p className="mb-4" data-id="element-152">You have the right to:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-153">
          <li data-id="element-154">
            <strong data-id="element-155">Access:</strong> Request access to your personal information
          </li>
          <li data-id="element-156">
            <strong data-id="element-157">Correction:</strong> Request correction of inaccurate
            information
          </li>
          <li data-id="element-158">
            <strong data-id="element-159">Deletion:</strong> Request deletion of your personal
            information
          </li>
          <li data-id="element-160">
            <strong data-id="element-161">Opt-Out:</strong> Unsubscribe from marketing communications
          </li>
          <li data-id="element-162">
            <strong data-id="element-163">Data Portability:</strong> Request a copy of your data in a
            portable format
          </li>
        </ul>
        <p data-id="element-164">
          To exercise these rights, please contact us at
          support@healthproductsguru.com
        </p>
      </section>

      <section className="mb-8" data-id="element-165">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-166">
          8. Children's Privacy
        </h3>
        <p data-id="element-167">
          Our Site is not intended for children under 18 years of age. We do not
          knowingly collect personal information from children. If you believe
          we have collected information from a child, please contact us
          immediately.
        </p>
      </section>

      <section className="mb-8" data-id="element-168">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-169">
          9. International Data Transfers
        </h3>
        <p data-id="element-170">
          Your information may be transferred to and processed in countries
          other than your country of residence. We ensure appropriate safeguards
          are in place to protect your information in accordance with this
          Privacy Policy.
        </p>
      </section>

      <section className="mb-8" data-id="element-171">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-172">
          10. Changes to This Privacy Policy
        </h3>
        <p data-id="element-173">
          We may update this Privacy Policy from time to time. We will notify
          you of any material changes by posting the new Privacy Policy on this
          page and updating the "Effective Date" at the top.
        </p>
      </section>

      <section className="mb-8" data-id="element-174">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-175">11. Contact Us</h3>
        <p className="mb-4" data-id="element-176">
          If you have any questions or concerns about this Privacy Policy or our
          privacy practices, please contact us at:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-177">
          <p className="font-semibold" data-id="element-178">HealthProductsGuru</p>
          <p data-id="element-179">Email: support@healthproductsguru.com</p>
          <p data-id="element-180">Website: healthproductsguru.com</p>
        </div>
      </section>
    </div>;
}
export function TermsOfServiceContent() {
  return <div className="prose prose-sm max-w-none text-gray-700" data-id="element-181">
      <p className="text-sm text-gray-500 mb-6" data-id="element-182">
        <strong data-id="element-183">Effective Date:</strong> January 1, 2025
      </p>

      <section className="mb-8" data-id="element-184">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-185">
          1. Acceptance of Terms
        </h3>
        <p data-id="element-186">
          Welcome to HealthProductsGuru. By accessing or using our website
          healthproductsguru.com (the "Site") and purchasing our products, you
          agree to be bound by these Terms of Service ("Terms"). If you do not
          agree to these Terms, please do not use our Site or purchase our
          products.
        </p>
      </section>

      <section className="mb-8" data-id="element-187">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-188">
          2. Product Information and Availability
        </h3>
        <p className="mb-4" data-id="element-189">
          We strive to provide accurate product descriptions, images, and
          pricing information. However, we do not warrant that product
          descriptions, images, pricing, or other content on the Site is
          accurate, complete, reliable, current, or error-free.
        </p>
        <p className="mb-4" data-id="element-190">
          Product availability is subject to change without notice. We reserve
          the right to limit quantities, discontinue products, or refuse orders
          at our sole discretion.
        </p>
      </section>

      <section className="mb-8" data-id="element-191">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-192">
          3. Orders and Payment
        </h3>

        <h4 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-193">
          3.1 Order Acceptance
        </h4>
        <p className="mb-4" data-id="element-194">
          Your order constitutes an offer to purchase products. We reserve the
          right to accept or decline your order for any reason, including
          product availability, errors in pricing or product information, or
          suspected fraud.
        </p>

        <h4 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-195">
          3.2 Pricing
        </h4>
        <p className="mb-4" data-id="element-196">
          All prices are in USD and are subject to change without notice. We
          reserve the right to correct pricing errors. If a product's correct
          price is higher than the stated price, we will contact you before
          processing your order.
        </p>

        <h4 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-197">
          3.3 Payment
        </h4>
        <p className="mb-4" data-id="element-198">
          Payment is due at the time of purchase. We accept major credit cards
          and other payment methods as indicated on the Site. By providing
          payment information, you represent that you are authorized to use the
          payment method.
        </p>
      </section>

      <section className="mb-8" data-id="element-199">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-200">
          4. Shipping and Delivery
        </h3>
        <p className="mb-4" data-id="element-201">
          We will ship your order to the address you provide. Shipping times are
          estimates and not guaranteed. We are not responsible for delays caused
          by shipping carriers or customs.
        </p>
        <p className="mb-4" data-id="element-202">
          Risk of loss and title for products pass to you upon delivery to the
          shipping carrier.
        </p>
      </section>

      <section className="mb-8" data-id="element-203">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-204">
          5. Return and Refund Policy
        </h3>
        <p className="mb-4" data-id="element-205">
          We offer a 180-day money-back guarantee on all products. If you are
          not satisfied with your purchase, you may return the product within
          180 days of delivery for a full refund, minus shipping costs.
        </p>
        <p className="mb-4" data-id="element-206">
          To initiate a return, please contact our customer service at
          support@healthproductsguru.com. Products must be returned in their
          original condition.
        </p>
        <p className="mb-4" data-id="element-207">
          Refunds will be processed within 7-10 business days after we receive
          your returned product.
        </p>
      </section>

      <section className="mb-8" data-id="element-208">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-209">
          6. Product Use and Health Disclaimers
        </h3>
        <p className="mb-4" data-id="element-210">
          <strong data-id="element-211">Important:</strong> Our products are dietary supplements and
          are not intended to diagnose, treat, cure, or prevent any disease. The
          statements on this Site have not been evaluated by the Food and Drug
          Administration (FDA).
        </p>
        <p className="mb-4" data-id="element-212">
          You should consult with a healthcare professional before using any
          dietary supplement, especially if you:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-213">
          <li data-id="element-214">Have a medical condition</li>
          <li data-id="element-215">Are taking prescription medications</li>
          <li data-id="element-216">Are pregnant or nursing</li>
          <li data-id="element-217">Are under 18 years of age</li>
        </ul>
        <p className="mb-4" data-id="element-218">
          Results may vary. Individual results are not guaranteed and may vary
          based on diet, exercise, and other factors.
        </p>
      </section>

      <section className="mb-8" data-id="element-219">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-220">
          7. Intellectual Property
        </h3>
        <p className="mb-4" data-id="element-221">
          All content on the Site, including text, graphics, logos, images, and
          software, is the property of HealthProductsGuru or its licensors and
          is protected by copyright, trademark, and other intellectual property
          laws.
        </p>
        <p className="mb-4" data-id="element-222">
          You may not reproduce, distribute, modify, or create derivative works
          from any content on the Site without our express written permission.
        </p>
      </section>

      <section className="mb-8" data-id="element-223">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-224">
          8. User Accounts
        </h3>
        <p className="mb-4" data-id="element-225">
          If you create an account on our Site, you are responsible for
          maintaining the confidentiality of your account credentials and for
          all activities that occur under your account.
        </p>
        <p className="mb-4" data-id="element-226">
          You agree to notify us immediately of any unauthorized use of your
          account. We are not liable for any loss or damage arising from your
          failure to protect your account information.
        </p>
      </section>

      <section className="mb-8" data-id="element-227">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-228">
          9. Prohibited Activities
        </h3>
        <p className="mb-4" data-id="element-229">You agree not to:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-230">
          <li data-id="element-231">Use the Site for any unlawful purpose</li>
          <li data-id="element-232">
            Attempt to gain unauthorized access to the Site or our systems
          </li>
          <li data-id="element-233">Interfere with or disrupt the Site's operation</li>
          <li data-id="element-234">Transmit viruses, malware, or other harmful code</li>
          <li data-id="element-235">Collect or harvest information about other users</li>
          <li data-id="element-236">Impersonate any person or entity</li>
          <li data-id="element-237">Engage in any fraudulent activity</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-238">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-239">
          10. Limitation of Liability
        </h3>
        <p className="mb-4" data-id="element-240">
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, HEALTHPRODUCTSGURU SHALL NOT
          BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
          PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED
          DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER
          INTANGIBLE LOSSES.
        </p>
        <p className="mb-4" data-id="element-241">
          OUR TOTAL LIABILITY TO YOU FOR ANY CLAIMS ARISING FROM YOUR USE OF THE
          SITE OR PRODUCTS SHALL NOT EXCEED THE AMOUNT YOU PAID FOR THE
          PRODUCTS.
        </p>
      </section>

      <section className="mb-8" data-id="element-242">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-243">
          11. Indemnification
        </h3>
        <p data-id="element-244">
          You agree to indemnify, defend, and hold harmless HealthProductsGuru
          and its officers, directors, employees, and agents from any claims,
          liabilities, damages, losses, and expenses arising from your use of
          the Site, violation of these Terms, or infringement of any third-party
          rights.
        </p>
      </section>

      <section className="mb-8" data-id="element-245">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-246">
          12. Governing Law and Dispute Resolution
        </h3>
        <p className="mb-4" data-id="element-247">
          These Terms shall be governed by and construed in accordance with the
          laws of the United States, without regard to its conflict of law
          provisions.
        </p>
        <p className="mb-4" data-id="element-248">
          Any disputes arising from these Terms or your use of the Site shall be
          resolved through binding arbitration in accordance with the rules of
          the American Arbitration Association.
        </p>
      </section>

      <section className="mb-8" data-id="element-249">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-250">
          13. Changes to Terms
        </h3>
        <p data-id="element-251">
          We reserve the right to modify these Terms at any time. We will notify
          you of material changes by posting the updated Terms on the Site with
          a new "Effective Date." Your continued use of the Site after changes
          constitutes acceptance of the modified Terms.
        </p>
      </section>

      <section className="mb-8" data-id="element-252">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-253">
          14. Severability
        </h3>
        <p data-id="element-254">
          If any provision of these Terms is found to be invalid or
          unenforceable, the remaining provisions shall remain in full force and
          effect.
        </p>
      </section>

      <section className="mb-8" data-id="element-255">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-256">
          15. Contact Information
        </h3>
        <p className="mb-4" data-id="element-257">
          If you have any questions about these Terms of Service, please contact
          us at:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-258">
          <p className="font-semibold" data-id="element-259">HealthProductsGuru</p>
          <p data-id="element-260">Email: support@healthproductsguru.com</p>
          <p data-id="element-261">Website: healthproductsguru.com</p>
        </div>
      </section>

      <section className="mb-8" data-id="element-262">
        <p className="text-sm text-gray-600 italic" data-id="element-263">
          By using our Site and purchasing our products, you acknowledge that
          you have read, understood, and agree to be bound by these Terms of
          Service.
        </p>
      </section>
    </div>;
}